<template>
  <div class="pa24 view">
    {{$t('article', 'employeeName')}}:{{ name }}
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          type="index"
          align="center"
          :label="$t('article', 'serialNumber')"
          show-overflow-tooltip
        />
        <el-table-column prop="title" align="center" :label="$t('article', 'articleTitle')" />
        <el-table-column prop="pubTime" align="center" :label="$t('article', 'publishTime')" />
        <el-table-column prop="shareNum" align="center" :label="$t('article', 'shareCount')" />
        <el-table-column prop="winCustomers" align="center" :label="$t('article', 'customerCount')" />
        <el-table-column prop="seeNum" align="center" :label="$t('article', 'viewCount')" />
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { queryStaffShareDetail } from "@/api/articleManagement";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  mixins: [i18nMixin],
  data() {
    return {
      name: "",
      userId: "",
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
    };
  },
  components: {
    commonTable,
  },
  created() {
    const { name, userId } = this.$route.query;
    this.name = name;
    this.userId = userId;
    this.queryStaffShareDetail();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryStaffShareDetail();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryStaffShareDetail();
    },
    async queryStaffShareDetail() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        userId: this.userId,
      };
      try {
        this.loading = true;
        const result = await queryStaffShareDetail(data);
        this.loading = false;
        console.log(result);
        
        console.log(result);
        const { total, list } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>